// ----------------------------------------------------------------------

const shape = {
  borderRadius: 5,
  borderRadiusSm: 10,
  borderRadiusMd: 15
};

export default shape;
